import { MapUtils } from '../../../utility/map-utils.js';

import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';

export class AutomatedMarketingSettings extends DataModel {
  static readonly TYPE_ID: string = 'f48c43235d3f43ea955193a2d5fc2afc';

  private constructor(
    public readonly onlineTicketFeePercentage: number,
    public readonly cashTicketFeePercentage: number,
    public readonly posTicketFeePercentage: number,
    public readonly onlinePassFeePercentage: number,
    public readonly cashPassFeePercentage: number,
    public readonly posPassFeePercentage: number,
  ) {
    super();
  }

  get $typeId(): string {
    return AutomatedMarketingSettings.TYPE_ID;
  }

  static create(args: {
    onlineTicketFeePercentage?: number,
    cashTicketFeePercentage?: number,
    posTicketFeePercentage?: number,
    onlinePassFeePercentage?: number,
    cashPassFeePercentage?: number,
    posPassFeePercentage?: number,
  }): AutomatedMarketingSettings {
    return new AutomatedMarketingSettings(
        args.onlineTicketFeePercentage ?? 0,
        args.cashTicketFeePercentage ?? 0,
        args.posTicketFeePercentage ?? 0,
        args.onlinePassFeePercentage ?? 0,
        args.cashPassFeePercentage ?? 0,
        args.posPassFeePercentage ?? 0,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): AutomatedMarketingSettings {
    return AutomatedMarketingSettings.create({
      onlineTicketFeePercentage: MapUtils.getDouble(map, 'onlineTicketFeePercentage'),
      cashTicketFeePercentage: MapUtils.getDouble(map, 'cashTicketFeePercentage'),
      posTicketFeePercentage: MapUtils.getDouble(map, 'posTicketFeePercentage'),
      onlinePassFeePercentage: MapUtils.getDouble(map, 'onlinePassFeePercentage'),
      cashPassFeePercentage: MapUtils.getDouble(map, 'cashPassFeePercentage'),
      posPassFeePercentage: MapUtils.getDouble(map, 'posPassFeePercentage'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'onlineTicketFeePercentage': this.onlineTicketFeePercentage,
      'cashTicketFeePercentage': this.cashTicketFeePercentage,
      'posTicketFeePercentage': this.posTicketFeePercentage,
      'onlinePassFeePercentage': this.onlinePassFeePercentage,
      'cashPassFeePercentage': this.cashPassFeePercentage,
      'posPassFeePercentage': this.posPassFeePercentage,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    onlineTicketFeePercentage = this.onlineTicketFeePercentage,
    cashTicketFeePercentage = this.cashTicketFeePercentage,
    posTicketFeePercentage = this.posTicketFeePercentage,
    onlinePassFeePercentage = this.onlinePassFeePercentage,
    cashPassFeePercentage = this.cashPassFeePercentage,
    posPassFeePercentage = this.posPassFeePercentage,
  }: {
    onlineTicketFeePercentage?: number,
    cashTicketFeePercentage?: number,
    posTicketFeePercentage?: number,
    onlinePassFeePercentage?: number,
    cashPassFeePercentage?: number,
    posPassFeePercentage?: number,
  } = {}): this {
    return AutomatedMarketingSettings.create({
      onlineTicketFeePercentage,
      cashTicketFeePercentage,
      posTicketFeePercentage,
      onlinePassFeePercentage,
      cashPassFeePercentage,
      posPassFeePercentage,
    }) as this;
  }

  isSame(other: AutomatedMarketingSettings): boolean {
    if(other === this) {
      return true;
    }

    return other.onlineTicketFeePercentage === this.onlineTicketFeePercentage &&
      other.cashTicketFeePercentage === this.cashTicketFeePercentage &&
      other.posTicketFeePercentage === this.posTicketFeePercentage &&
      other.onlinePassFeePercentage === this.onlinePassFeePercentage &&
      other.cashPassFeePercentage === this.cashPassFeePercentage &&
      other.posPassFeePercentage === this.posPassFeePercentage;
  }
}

export class AutomatedMarketingSettingsBuilder extends DataModelBuilder<AutomatedMarketingSettings> {
  build(context: SerializationContext, map: SerializedData): AutomatedMarketingSettings {
    return AutomatedMarketingSettings.fromMap(context, map);
  }
}
